export const navHeight = {
  base: "50px",
  lg: "72px",
};

export const tabHeight = {
  base: "56px",
  lg: "100vh",
};
